export const discQuestions = [
  {
    id: 1,
    options: [
      { text: "Enthusiastisch", type: "I", most: true },
      { text: "Wagemutig", type: "D", most: true },
      { text: "Diplomatisch", type: "C", most: true },
      { text: "Zufrieden", type: "S", most: true }
    ]
  },
  {
    id: 2,
    options: [
      { text: "Vorsichtig", type: "C", most: true },
      { text: "Entschlossen", type: "D", most: true },
      { text: "Überzeugend", type: "I", most: true },
      { text: "Gutmütig", type: "S", most: true }
    ]
  },
  {
    id: 3,
    options: [
      { text: "Freundlich", type: "I", most: true },
      { text: "Genau", type: "C", most: true },
      { text: "Aufrichtig", type: "D", most: true },
      { text: "Ruhig", type: "S", most: true }
    ]
  },
  {
    id: 4,
    options: [
      { text: "Gesprächig", type: "I", most: true },
      { text: "Beherrscht", type: "C", most: true },
      { text: "Konventionell", type: "S", most: true },
      { text: "Entscheidungsfreudig", type: "D", most: true }
    ]
  },
  {
    id: 5,
    options: [
      { text: "Abenteuerlustig", type: "D", most: true },
      { text: "Einfühlsam", type: "C", most: true },
      { text: "Aufgeschlossen", type: "I", most: true },
      { text: "Gemäßigt", type: "S", most: true }
    ]
  },
  {
    id: 6,
    options: [
      { text: "Sanft", type: "S", most: true },
      { text: "Überredend", type: "I", most: true },
      { text: "Bescheiden", type: "C", most: true },
      { text: "Originell", type: "D", most: true }
    ]
  },
  {
    id: 7,
    options: [
      { text: "Ausdrucksstark", type: "I", most: true },
      { text: "Gewissenhaft", type: "C", most: true },
      { text: "Dominierend", type: "D", most: true },
      { text: "Aufnahmefähig", type: "S", most: true }
    ]
  },
  {
    id: 8,
    options: [
      { text: "Gelassen", type: "S", most: true },
      { text: "Beobachtend", type: "C", most: true },
      { text: "Bescheiden", type: "S", most: true },
      { text: "Ungeduldig", type: "D", most: true }
    ]
  },
  {
    id: 9,
    options: [
      { text: "Taktvoll", type: "C", most: true },
      { text: "Verträglich", type: "S", most: true },
      { text: "Magnetisch", type: "I", most: true },
      { text: "Beharrlich", type: "D", most: true }
    ]
  },
  {
    id: 10,
    options: [
      { text: "Mutig", type: "D", most: true },
      { text: "Inspirierend", type: "I", most: true },
      { text: "Unterwürfig", type: "S", most: true },
      { text: "Schüchtern", type: "C", most: true }
    ]
  },
  {
    id: 11,
    options: [
      { text: "Reserviert", type: "C", most: true },
      { text: "Gefällig", type: "S", most: true },
      { text: "Willensstark", type: "D", most: true },
      { text: "Fröhlich", type: "I", most: true }
    ]
  },
  {
    id: 12,
    options: [
      { text: "Stimulierend", type: "I", most: true },
      { text: "Freundlich", type: "S", most: true },
      { text: "Aufmerksam", type: "C", most: true },
      { text: "Unabhängig", type: "D", most: true }
    ]
  },
  {
    id: 13,
    options: [
      { text: "Wettbewerbsorientiert", type: "D", most: true },
      { text: "Rücksichtsvoll", type: "S", most: true },
      { text: "Freudig", type: "I", most: true },
      { text: "Privat", type: "C", most: true }
    ]
  },
  {
    id: 14,
    options: [
      { text: "Pingelig", type: "C", most: true },
      { text: "Gehorsam", type: "S", most: true },
      { text: "Bestimmt", type: "D", most: true },
      { text: "Verspielt", type: "I", most: true }
    ]
  },
  {
    id: 15,
    options: [
      { text: "Attraktiv", type: "I", most: true },
      { text: "Nachdenklich", type: "C", most: true },
      { text: "Hartnäckig", type: "D", most: true },
      { text: "Vorhersagbar", type: "S", most: true }
    ]
  },
  {
    id: 16,
    options: [
      { text: "Logisch", type: "C", most: true },
      { text: "Kühn", type: "D", most: true },
      { text: "Loyal", type: "S", most: true },
      { text: "Charmant", type: "I", most: true }
    ]
  },
  {
    id: 17,
    options: [
      { text: "Gesellig", type: "I", most: true },
      { text: "Geduldig", type: "S", most: true },
      { text: "Selbständig", type: "D", most: true },
      { text: "Leise sprechend", type: "C", most: true }
    ]
  },
  {
    id: 18,
    options: [
      { text: "Bereitwillig", type: "S", most: true },
      { text: "Eifrig", type: "I", most: true },
      { text: "Gründlich", type: "C", most: true },
      { text: "Temperamentvoll", type: "D", most: true }
    ]
  },
  {
    id: 19,
    options: [
      { text: "Aggressiv", type: "D", most: true },
      { text: "Extrovertiert", type: "I", most: true },
      { text: "Liebenswürdig", type: "S", most: true },
      { text: "Ängstlich", type: "C", most: true }
    ]
  },
  {
    id: 20,
    options: [
      { text: "Selbstbewusst", type: "D", most: true },
      { text: "Sympathisch", type: "S", most: true },
      { text: "Unparteiisch", type: "C", most: true },
      { text: "Durchsetzungsfähig", type: "I", most: true }
    ]
  },
  {
    id: 21,
    options: [
      { text: "Diszipliniert", type: "C", most: true },
      { text: "Großzügig", type: "S", most: true },
      { text: "Lebhaft", type: "I", most: true },
      { text: "Beharrlich", type: "D", most: true }
    ]
  },
  {
    id: 22,
    options: [
      { text: "Impulsiv", type: "I", most: true },
      { text: "Introvertiert", type: "C", most: true },
      { text: "Kraftvoll", type: "D", most: true },
      { text: "Unkompliziert", type: "S", most: true }
    ]
  },
  {
    id: 23,
    options: [
      { text: "Gesellschaftlich", type: "I", most: true },
      { text: "Kultiviert", type: "C", most: true },
      { text: "Energisch", type: "D", most: true },
      { text: "Nachgiebig", type: "S", most: true }
    ]
  },
  {
    id: 24,
    options: [
      { text: "Fesselnd", type: "I", most: true },
      { text: "Zufrieden", type: "S", most: true },
      { text: "Fordernd", type: "D", most: true },
      { text: "Folgsam", type: "C", most: true }
    ]
  },
  {
    id: 25,
    options: [
      { text: "Streitlustig", type: "D", most: true },
      { text: "Systematisch", type: "C", most: true },
      { text: "Kooperativ", type: "S", most: true },
      { text: "Unbeschwert", type: "I", most: true }
    ]
  },
  {
    id: 26,
    options: [
      { text: "Jovial", type: "I", most: true },
      { text: "Präzise", type: "C", most: true },
      { text: "Direkt", type: "D", most: true },
      { text: "Ausgeglichen", type: "S", most: true }
    ]
  },
  {
    id: 27,
    options: [
      { text: "Rastlos", type: "D", most: true },
      { text: "Nachbarschaftlich", type: "S", most: true },
      { text: "Ansprechend", type: "I", most: true },
      { text: "Sorgfältig", type: "C", most: true }
    ]
  },
  {
    id: 28,
    options: [
      { text: "Respektvoll", type: "S", most: true },
      { text: "Wegweisend", type: "D", most: true },
      { text: "Optimistisch", type: "I", most: true },
      { text: "Hilfsbereit", type: "C", most: true }
    ]
  }
];